export default __webpack_public_path__ + "ec30fad0b3e1128ac8ca31623b4e2327.png";